import axios from 'axios'

class LinhasFornecimentoApiClient {

    async adicionar(compraDiretaId, linha) {
        return await axios.post(`/compra-direta/api/v1/comprador/compras-diretas/${compraDiretaId}/linhas-fornecimento`, linha)
    }

    async buscar(conteudo) {
        const parametroConteudo = conteudo ? `?conteudo=${conteudo}` : ''
        return await axios.get(`/compra-direta/api/v1/linhas-fornecimento${parametroConteudo}`)
    }

    async buscarDaCompraDireta(compraDiretaId) {
        return await axios.get(`/compra-direta/api/v1/comprador/compras-diretas/${compraDiretaId}/linhas-fornecimento`)
    }

    async excluir(compraDiretaId, linhaFornecimentoCompraDiretaId) {
        return await axios.delete(`/compra-direta/api/v1/comprador/compras-diretas/${compraDiretaId}/linhas-fornecimento/${linhaFornecimentoCompraDiretaId}`)
    }

}

export default new LinhasFornecimentoApiClient()
